/**
 * ILLTOCHILL Header Logic (Redesigned - Grid Layout)
 * Handles:
 * 1. Mega Menu Open/Close (Hover L1)
 * 2. Grid Content Switching (Hover L1)
 * 3. Headroom Behavior
 */

document.addEventListener('DOMContentLoaded', () => {

    // --- Config & Selectors ---
    const headerWrapper = document.querySelector('.illtochill-header-wrapper');
    const header = document.querySelector('.illtochill-header-section');
    const overlay = document.querySelector('.illtochill-mega-menu-overlay');
    const l1Items = document.querySelectorAll('.illtochill-nav__item.level-1-item');
    const icons = document.querySelectorAll('.illtochill-header__icon');
    // const megaMenuHeight = 500; // Unused, now using 100vh
    let isMenuOpen = false;
    let activeL1 = null;
    const isHomePage = document.body.classList.contains('template-index');

    // Safety Checks
    if (typeof gsap === 'undefined') console.warn('GSAP is missing.');
    if (typeof anime === 'undefined') console.warn('Anime.js is missing.');
    
    // Prevent Shopify's StickyHeader from hiding our header on ALL pages
    const sectionHeader = document.querySelector('.section-header');
    if (sectionHeader && header) {
        // Remove any hidden classes that might be added
        sectionHeader.classList.remove('shopify-section-header-hidden');
        sectionHeader.classList.add('shopify-section-header-sticky');
        
        // Watch for class changes and prevent hiding
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (sectionHeader.classList.contains('shopify-section-header-hidden')) {
                        sectionHeader.classList.remove('shopify-section-header-hidden');
                        sectionHeader.classList.add('shopify-section-header-sticky');
                    }
                }
            });
        });
        
        observer.observe(sectionHeader, {
            attributes: true,
            attributeFilter: ['class']
        });
        
        // Override the StickyHeader's hide method if it exists - prevent hiding on ALL pages
        const stickyHeaderElement = document.querySelector('sticky-header');
        if (stickyHeaderElement && stickyHeaderElement.header) {
            // Store original hide method
            const originalHide = stickyHeaderElement.hide;
            stickyHeaderElement.hide = function() {
                // Don't hide - keep header visible at all times
                return;
            };
        }
    }

    // --- 0. Headroom Logic ---
    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateHeadroom() {
        const currentScrollY = window.scrollY;
        
        // Always keep header sticky and visible on ALL pages
        if (headerWrapper) {
            // Force sticky class on all pages
            headerWrapper.classList.add('sticky-header');
            // Always keep header visible - never hide
            headerWrapper.classList.remove('header-hidden');
            headerWrapper.classList.add('header-visible');
            
            // Add scrolled class for styling when scrolled past top
            if (currentScrollY > 10) {
                headerWrapper.classList.add('scrolled-glass');
            } else {
                headerWrapper.classList.remove('scrolled-glass');
            }
        }
        
        lastScrollY = currentScrollY;
        ticking = false;
    }
    
    // Initialize sticky header on page load - run immediately on ALL pages
    if (headerWrapper) {
        // Force sticky on all pages
        headerWrapper.classList.add('sticky-header');
        headerWrapper.classList.remove('header-hidden');
        headerWrapper.classList.add('header-visible');
        // Run immediately
        updateHeadroom();
    }
    
    // Also run on initial load to ensure it's set on all pages
    if (headerWrapper) {
        setTimeout(() => {
            headerWrapper.classList.add('sticky-header');
            headerWrapper.classList.remove('header-hidden');
            headerWrapper.classList.add('header-visible');
        }, 0);
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(updateHeadroom);
            ticking = true;
        }
        
        // Prevent Shopify's StickyHeader from hiding the header on ALL pages
        const sectionHeader = document.querySelector('.section-header');
        if (sectionHeader) {
            sectionHeader.classList.remove('shopify-section-header-hidden');
            sectionHeader.classList.add('shopify-section-header-sticky');
            // Force position
            sectionHeader.style.top = '0';
            sectionHeader.style.transform = 'none';
        }
    });

    // --- 1. Mega Menu Trigger (Level 1) ---
    
    // Find Mental Health and Chronic Health items
    const mentalHealthItem = Array.from(l1Items).find(item => {
        const link = item.querySelector('.illtochill-nav__link');
        return link && (link.textContent.trim().toLowerCase().includes('mental') || 
                       item.getAttribute('data-title').toLowerCase().includes('mental') ||
                       item.getAttribute('data-title').toLowerCase().includes('nuro'));
    });
    
    const chronicHealthItem = Array.from(l1Items).find(item => {
        const link = item.querySelector('.illtochill-nav__link');
        return link && (link.textContent.trim().toLowerCase().includes('chronic') || 
                       item.getAttribute('data-title').toLowerCase().includes('chronic') ||
                       item.getAttribute('data-title').toLowerCase().includes('unbreakable'));
    });

    l1Items.forEach(item => {
        item.addEventListener('mouseenter', () => {
            const title = item.getAttribute('data-title');
            openMegaMenu(title);
            
            // Handle Mental/Chronic Health highlighting
            if (mentalHealthItem && chronicHealthItem) {
                if (item === mentalHealthItem || item === chronicHealthItem) {
                    // Highlight the hovered item
                    item.classList.add('is-highlighted');
                    item.classList.remove('is-dulled');
                    activeHealthItem = item;
                    
                    // Dull the other item
                    const otherItem = item === mentalHealthItem ? chronicHealthItem : mentalHealthItem;
                    otherItem.classList.add('is-dulled');
                    otherItem.classList.remove('is-highlighted');
                } else {
                    // Reset both when hovering other items
                    mentalHealthItem.classList.remove('is-highlighted', 'is-dulled');
                    chronicHealthItem.classList.remove('is-highlighted', 'is-dulled');
                    activeHealthItem = null;
                }
            }
        });
        
        item.addEventListener('mouseleave', (e) => {
            // Don't reset if moving to dropdown overlay
            if (overlay && overlay.contains(e.relatedTarget)) {
                return;
            }
            // Reset highlighting when leaving the item (and not going to dropdown)
            if (mentalHealthItem && chronicHealthItem) {
                if (item === mentalHealthItem || item === chronicHealthItem) {
                    // Only reset if menu is closing
                    if (!isMenuOpen) {
                        item.classList.remove('is-highlighted', 'is-dulled');
                        const otherItem = item === mentalHealthItem ? chronicHealthItem : mentalHealthItem;
                        otherItem.classList.remove('is-highlighted', 'is-dulled');
                        activeHealthItem = null;
                    }
                }
            }
        });
    });

    // Track which health item is currently active
    let activeHealthItem = null;
    
    if (header) {
        header.addEventListener('mouseleave', (e) => {
            // Only close if not moving to overlay
            if (!overlay || !overlay.contains(e.relatedTarget)) {
                closeMegaMenu();
                // Reset highlighting when leaving header
                if (mentalHealthItem && chronicHealthItem) {
                    mentalHealthItem.classList.remove('is-highlighted', 'is-dulled');
                    chronicHealthItem.classList.remove('is-highlighted', 'is-dulled');
                }
                activeHealthItem = null;
            }
        });
    }
    
    // Keep highlighting when hovering over dropdown
    if (overlay) {
        overlay.addEventListener('mouseenter', () => {
            // Maintain highlighting when entering dropdown
            if (activeHealthItem && mentalHealthItem && chronicHealthItem) {
                activeHealthItem.classList.add('is-highlighted');
                activeHealthItem.classList.remove('is-dulled');
                const otherItem = activeHealthItem === mentalHealthItem ? chronicHealthItem : mentalHealthItem;
                otherItem.classList.add('is-dulled');
                otherItem.classList.remove('is-highlighted');
            }
        });
        
        overlay.addEventListener('mouseleave', () => {
            closeMegaMenu();
            // Reset highlighting when leaving dropdown
            if (mentalHealthItem && chronicHealthItem) {
                mentalHealthItem.classList.remove('is-highlighted', 'is-dulled');
                chronicHealthItem.classList.remove('is-highlighted', 'is-dulled');
            }
            activeHealthItem = null;
        });
    }

    // --- Helper: Calculate Scrollbar Width ---
    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    function openMegaMenu(l1Title) {
        if (!isMenuOpen) {
            // Scroll Lock
            const scrollbarWidth = getScrollbarWidth();
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            document.body.classList.add('body-scroll-lock');
            document.body.classList.add('body-blur-active');

            // Anim: Fade In + Slide Down
            if (typeof gsap !== 'undefined') {
                gsap.set(overlay, { autoAlpha: 1 });
                gsap.fromTo(overlay,
                    { height: 0 },
                    { height: '100vh', duration: 0.3, ease: 'power2.out' }
                );
            } else {
                overlay.style.visibility = 'visible';
                overlay.style.opacity = '1';
                overlay.style.height = '100vh';
            }
            isMenuOpen = true;
        }

        // Switch Content
        if (activeL1 !== l1Title) {
            switchGridContent(l1Title);
            activeL1 = l1Title;
        }
    }

    function closeMegaMenu() {
        if (!isMenuOpen) return;

        // Unlock Scroll
        document.body.classList.remove('body-scroll-lock');
        document.body.classList.remove('body-blur-active');
        document.body.style.paddingRight = '';

        if (typeof gsap !== 'undefined') {
            gsap.to(overlay, {
                height: 0, duration: 0.25, ease: 'power2.in', onComplete: () => {
                    gsap.set(overlay, { autoAlpha: 0 });
                }
            });
        } else {
            overlay.style.visibility = 'hidden';
            overlay.style.opacity = '0';
        }
        isMenuOpen = false;
        activeL1 = null;
    }

    function switchGridContent(l1Title) {
        const grids = document.querySelectorAll('.mega-menu-grid-wrapper');

        grids.forEach(grid => {
            grid.style.display = 'none';
            grid.classList.remove('active');
        });

        const activeGrid = document.querySelector(`.mega-menu-grid-wrapper[data-parent-title="${l1Title}"]`);
        if (activeGrid) {
            activeGrid.style.display = 'block';
            activeGrid.classList.add('active');

            // Quick Stagger Animation for Links
            if (typeof anime !== 'undefined') {
                const items = activeGrid.querySelectorAll('a');
                anime.remove(items);
                anime({
                    targets: items,
                    translateY: [10, 0],
                    opacity: [0, 1],
                    delay: anime.stagger(20),
                    easing: 'easeOutQuad',
                    duration: 300
                });
            }
        }
    }

    // --- 2. Icon Micro-Animations ---
    icons.forEach(icon => {
        icon.addEventListener('mouseenter', () => {
            if (typeof anime === 'undefined') return;
            anime({
                targets: icon,
                scale: [1, 1.15],
                duration: 400,
                easing: 'easeOutElastic(1, .5)'
            });
        });
        icon.addEventListener('mouseleave', () => {
            if (typeof anime === 'undefined') return;
            anime({
                targets: icon,
                scale: 1,
                duration: 300,
                easing: 'easeOutQuad'
            });
        });
    });

});
